module.exports = __webpack_public_path__ + "static/social-banner-8b90d836a5b79cb62633a733edb29782.jpg";